import React, { useState } from 'react';
import { Phone, MapPin, CalendarCheck } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { BookingFlow } from './booking/BookingFlow';
import { ServiceAreaMap } from './ServiceAreaMap';

const ContactItem = ({ Icon, title, children, testId }) => (
  <div className="group bg-white border border-neutral-200 hover:border-red-600 rounded-sm p-8 text-center shadow-sm transition-colors duration-300" data-testid={testId}>
    <div className="w-14 h-14 bg-red-600 rounded-sm flex items-center justify-center mx-auto mb-4 group-hover:-translate-y-1 transition-transform duration-300">
      <Icon className="w-7 h-7 text-white" />
    </div>
    <h3 className="font-display uppercase text-lg font-bold text-neutral-950 mb-2">{title}</h3>
    {children}
  </div>
);

export const Contact = () => {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="font-display uppercase tracking-[0.25em] text-sm font-semibold text-red-600">Get In Touch</span>
          <h2 className="font-display italic uppercase text-4xl md:text-5xl font-extrabold text-neutral-950 mt-2 mb-3">Contact Us</h2>
          <p className="text-neutral-600 text-base md:text-lg">Ready to transform your vehicle? Get in touch.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <ContactItem Icon={Phone} title="Call Us" testId="contact-call">
            <a href={`tel:${businessInfo.phone}`} className="text-neutral-700 hover:text-red-600 text-lg font-semibold" data-testid="contact-phone-link">
              {businessInfo.phone}
            </a>
          </ContactItem>
          <ContactItem Icon={MapPin} title="Service Area" testId="contact-area">
            <p className="text-neutral-700 text-lg">{businessInfo.serviceArea}</p>
          </ContactItem>
          <ContactItem Icon={CalendarCheck} title="Book Online" testId="contact-book">
            <button type="button" onClick={() => setBookingOpen(true)} className="text-neutral-700 hover:text-red-600 text-lg font-semibold" data-testid="contact-book-link">
              Schedule Now
            </button>
          </ContactItem>
        </div>

        <ServiceAreaMap />
      </div>

      <BookingFlow open={bookingOpen} onClose={() => setBookingOpen(false)} serviceName={null} />
    </section>
  );
};
